module.exports = __webpack_public_path__ + "media/animacion-2d-3d_reel.59079f5e.mp4";